import { EMAIL_METRICS } from './constants';
import { EmailTotals } from './totals';

interface Props {
  totals: EmailTotals;
}

export default function EmailKpis({ totals }: Props) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
      {EMAIL_METRICS.map(metric => (
        <div
          key={metric.key}
          className="bg-white p-4 rounded shadow border-l-4"
          style={{ borderLeftColor: metric.color }}
          title={metric.help}
        >
          <span className="block text-xs uppercase text-gray-500">{metric.label}</span>
          <span className="block text-2xl font-bold">{(totals[metric.key] || 0).toLocaleString('pt-BR')}</span>
        </div>
      ))}
    </div>
  );
}
